import { Text, VStack } from '@chakra-ui/react';

import { useTranslation } from 'react-i18next';

export default function AIAgentError() {
  const { t } = useTranslation();

  return (
    <VStack
      backgroundColor="red.300"
      paddingX={4}
      paddingY={3}
      borderRadius="12px"
      width="fit-content"
      margin="0 auto"
      marginTop={12}
    >
      <Text fontSize="14px" fontWeight={600} color="white">
        {t('aiAgent.error1')}
      </Text>

      <Text fontSize="14px" fontWeight={400} color="white">
        {t('aiAgent.error2')}
      </Text>
    </VStack>
  );
}
